module.exports = __webpack_public_path__ + "img/awesome-chess-knight.9bbbb7a2.svg";